// admin-ui/src/components/MetricCard.tsx
// ALL RIGHTS RESERVED

/**
 * Metric Card
 * Single metric display with optional status indicator
 */

// ═══════════════════════════════════════════════════════
// TYPES
// ═══════════════════════════════════════════════════════

interface MetricCardProps {
  title: string;
  value: string;
  subtitle?: string;
  trend?: {
    direction: 'up' | 'down' | 'flat';
    value: string;
  } | null;
  status?: 'success' | 'warning' | 'error' | 'neutral';
}

// ═══════════════════════════════════════════════════════
// COMPONENT
// ═══════════════════════════════════════════════════════

export function MetricCard({ 
  title, 
  value, 
  subtitle, 
  trend,
  status = 'neutral',
}: MetricCardProps) {
  return (
    <div className={`metric-card status-${status}`}>
      <h3 className="metric-title">{title}</h3>
      <div className="metric-value">{value}</div>
      {subtitle && (
        <div className={`metric-subtitle ${status !== 'neutral' ? status : ''}`}>
          {subtitle}
        </div>
      )}
      {trend && (
        <div className={`metric-trend trend-${trend.direction}`}>
          <span className="trend-arrow">
            {trend.direction === 'up' ? '↑' : trend.direction === 'down' ? '↓' : '→'}
          </span>
          <span className="trend-value">{trend.value}</span>
        </div>
      )}
    </div>
  );
}

export default MetricCard;
